export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "auth.worker.db6cb0464e2bdbc89cb9.worker.js");
}
